'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const A11yDiv = _ref => {
  let {
    style = {},
    onClick,
    ...attrs
  } = _ref;
  if (!onClick) return /*#__PURE__*/React__default["default"].createElement("div", _extends__default["default"]({
    style: style
  }, attrs));
  const handleKeyDown = event => {
    const keyCode = event.nativeEvent.code;
    if (keyCode === 'Enter' || keyCode === 'Space') {
      onClick(event);
    }
  };
  return /*#__PURE__*/React__default["default"].createElement("div", _extends__default["default"]({
    role: "button",
    onClick: onClick,
    onKeyDown: handleKeyDown,
    tabIndex: 0
  }, attrs, {
    style: {
      cursor: 'pointer',
      ...style
    }
  }));
};

exports["default"] = A11yDiv;
